module.exports = __webpack_public_path__ + "img/az.60be8f81.jpg";